import { z } from 'zod'

/**
 t('missedCandidate.failure.inactive_campaign')
 t('missedCandidate.failure.company_not_subscribed')
 t('missedCandidate.failure.duplicate_phone')
 t('missedCandidate.failure.company_conversation_limit_reached')
 t('missedCandidate.failure.campaign_conversation_limit_reached')
 t('missedCandidate.failure.invalid_phone')
 t('missedCandidate.failure.missing_required_fields')
 t('missedCandidate.failure.unknown')
 */
export const missedCandidateFailureType = z.enum([
    'inactive_campaign',
    'company_not_subscribed',
    'duplicate_phone',
    'company_conversation_limit_reached',
    'campaign_conversation_limit_reached',
    'invalid_phone',
    'missing_required_fields',
    'unknown',
])

export const missedCandidate = z.object({
    id: z.string(),
    campaignId: z.string(),
    resolvedCandidateId: z.string().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    failureType: missedCandidateFailureType,
    resolvedAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
})

export type MissedCandidate = z.infer<typeof missedCandidate>
export type MissedCandidateFailureType = z.infer<typeof missedCandidateFailureType>
